var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 616 497.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-face-base-1 {\n        fill: #ffb07b;\n      }\n\n      .cls-skin-color {\n        fill: var(--custom-skin-color, #dd8f5f) !important;\n      }\n\n      .cls-face-base-3 {\n        fill: #fff;\n      }\n\n      .cls-face-base-4 {\n        fill: #42210b;\n      }\n\n      .cls-face-base-5 {\n        fill: #f44d41;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-skin-color",
    cx: 551.16,
    cy: 346.91,
    r: 64.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-skin-color",
    cx: 64.84,
    cy: 346.91,
    r: 64.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-1",
    d: "M64.84,282.06c-9.22,0-17.99,1.94-25.94,5.41v24.99c0,36.53,10.65,70.54,28.95,99.2,34.41-1.57,61.83-29.96,61.83-64.77s-29.03-64.84-64.84-64.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-1",
    d: "M551.16,282.06c9.22,0,17.99,1.94,25.94,5.41v24.99c0,36.53-10.65,70.54-28.95,99.2-34.41-1.57-61.83-29.96-61.83-64.77,0-35.81,29.03-64.84,64.84-64.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M308,0h0C449.36,0,564.13,114.77,564.13,256.13v56.34c0,101.91-82.74,184.65-184.65,184.65h-142.94c-101.91,0-184.65-82.74-184.65-184.65v-56.34C51.87,114.77,166.64,0,308,0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-face-base-5",
    x: 274.75,
    y: 306.56,
    width: 60.83,
    height: 41.28,
    rx: 20.64,
    ry: 20.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-4",
    d: "M308.89,422.56c-25.24,0-48.05-16.3-56.97-40.12-1.33-3.54.71-7.46,4.38-8.38h0c3.09-.77,6.29.87,7.4,3.86,7.25,19.48,26.1,32.65,46.72,31.99,18.65-.62,35.56-12.79,42.81-30.24,1.21-2.92,4.49-4.4,7.52-3.52h.01c3.61,1.05,5.52,5.01,4.09,8.49-9.16,22.15-30.09,37.09-54.01,37.89-.65.02-1.3.03-1.94.03Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-face-base-3",
    cx: 179.58,
    cy: 251.88,
    rx: 57.84,
    ry: 59.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-4",
    d: "M179.58,314.29c-33.67,0-61.06-28-61.06-62.41s27.39-62.41,61.06-62.41,61.06,28,61.06,62.41-27.39,62.41-61.06,62.41ZM179.58,195.9c-30.12,0-54.63,25.11-54.63,55.98s24.51,55.98,54.63,55.98,54.63-25.11,54.63-55.98-24.51-55.98-54.63-55.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-face-base-4",
    cx: 200.5,
    cy: 252.03,
    rx: 35.69,
    ry: 36.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-4",
    d: "M200.5,291.77c-21.45,0-38.9-17.83-38.9-39.74s17.45-39.74,38.9-39.74,38.9,17.83,38.9,39.74-17.45,39.74-38.9,39.74ZM200.5,218.71c-17.91,0-32.48,14.94-32.48,33.31s14.57,33.31,32.48,33.31,32.48-14.95,32.48-33.31-14.57-33.31-32.48-33.31Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-4",
    d: "M223.51,185.5c-4.78-4.23-22.32-17.92-46.94-16.34-19.14,1.21-32.51,10.75-38.77,16.33l-4.27-4.8c6.88-6.13,21.58-16.62,42.64-17.95,26.39-1.66,44.87,11.99,51.6,17.94l-4.26,4.82Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-face-base-3",
    cx: 425.94,
    cy: 251.88,
    rx: 57.84,
    ry: 59.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-4",
    d: "M425.94,314.29c-33.67,0-61.06-28-61.06-62.41s27.39-62.41,61.06-62.41,61.06,28,61.06,62.41-27.39,62.41-61.06,62.41ZM425.94,195.9c-30.12,0-54.63,25.11-54.63,55.98s24.51,55.98,54.63,55.98,54.63-25.11,54.63-55.98-24.51-55.98-54.63-55.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-face-base-4",
    cx: 446.87,
    cy: 252.03,
    rx: 35.69,
    ry: 36.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-4",
    d: "M446.87,291.77c-21.45,0-38.9-17.83-38.9-39.74s17.45-39.74,38.9-39.74,38.9,17.83,38.9,39.74-17.45,39.74-38.9,39.74ZM446.87,218.71c-17.91,0-32.48,14.94-32.48,33.31s14.57,33.31,32.48,33.31,32.48-14.95,32.48-33.31-14.57-33.31-32.48-33.31Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-4",
    d: "M469.88,185.5c-4.78-4.23-22.31-17.92-46.94-16.34-19.14,1.21-32.51,10.75-38.77,16.33l-4.27-4.8c6.88-6.13,21.58-16.62,42.64-17.95,26.39-1.66,44.87,11.99,51.6,17.94l-4.26,4.82Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace2);
export default __webpack_public_path__ + "static/media/face2.360b09968828f0cc97d096b73acc6af8.svg";
export { ForwardRef as ReactComponent };